module.exports = __webpack_public_path__ + "static/media/parnaiba-pi.026ca589.jpg";